// Copyright (C) 2020-2022 Intel Corporation
//
// SPDX-License-Identifier: MIT

import React, { ReactPortal, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch } from 'react-redux';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import { Row, Col } from 'antd/lib/grid';

import { reviewActions, finishIssueAsync } from 'actions/review-actions';
import { Store } from 'antd/lib/form/interface';

interface FormProps {
    top: number;
    left: number;
    angle: number;
    scale: number;
    submit(message: string, object_id: any): void;
    cancel(): void;
    object_id: number| null;
}

function MessageForm(props: FormProps): JSX.Element {
    const {
        top, left, angle, scale, submit, cancel, object_id,
    } = props;

    function handleSubmit(values: Store): void {
        submit(values.issue_description, object_id);
    }
    let offsetX = 0;
    let offsetY = 0;
    let isDragging = false;
 useEffect(() => {
        const wrapper = document.getElementById("draggle");
      wrapper?.addEventListener("mousedown", (e) => {
        isDragging =true;
        offsetX = e.clientX-wrapper.offsetLeft;
        offsetY =e.clientY-wrapper.offsetTop;
        wrapper.style.cursor = 'grabbing';
      });
      document.addEventListener("mousemove", (e) => {
        if(!isDragging) return;
       const x = e.clientX-offsetX;
       const y = e.clientY-offsetY;
       wrapper.style.left = `${x}px`;
        wrapper.style.top = `${y}px`;
      });
      document.addEventListener("mouseup", () => {
        isDragging = false;
        wrapper.style.cursor = 'grab';
          });
      return () => {
    };
        }, [true]);
    return (
        <div>
        <Form
           id='draggle' className='cvat-create-issue-dialog'
            style={{ top, left, transform: `scale(${scale}) rotate(${angle}deg)` }}
            onFinish={(values: Store) => handleSubmit(values)}
        >
            <Form.Item name='issue_description' rules={[{ required: true, message: 'Please, fill out the field' }]}>
                <Input autoComplete='off' placeholder='Please, describe the issue' />
            </Form.Item>
            <Row justify='space-between'>
                <Col>
                    <Button onClick={cancel} type='ghost' className='cvat-create-issue-dialog-cancel-button'>
                        Cancel
                    </Button>
                </Col>
                <Col>
                    <Button type='primary' htmlType='submit' className='cvat-create-issue-dialog-submit-button'>
                        Submit
                    </Button>
                </Col>
            </Row>
        </Form>
        </div>
    );
}

interface Props {
    top: number;
    left: number;
    angle: number;
    scale: number;
    object_id: number | null;
}

export default function CreateIssueDialognew3d(props: Props): ReactPortal {
    const dispatch = useDispatch();
    const {
        top, left, angle, scale, object_id,
    } = props;
    return ReactDOM.createPortal(
        <MessageForm
            top={top}
            left={left}
            angle={angle}
            scale={scale}
            object_id={object_id}
            submit={(message: string) => {
                dispatch(finishIssueAsync(message, object_id));
            }}
            cancel={() => {
                dispatch(reviewActions.cancelIssue());
            }}
        />,
        // window.document.getElementById('cvat_canvas_attachment_board') as HTMLElement,
        window.document.body,
    );
}
